<template>
  <Wrapper
    v-show="
      !preview && renderTools &&
      !['reheight_widget', 'remargin_widget', 'sort_widget', 'reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode) &&
      cellHover.id &&
      (cellHover.id != cellActive.id || (cellHover.id == cellActive.id && widgetActive.id))
    "
    :position="cellHover.position"
    class="cell-hover"
    id="cell-hover-frame"
    :class="{'top': !isOverScroll, 'bottom': isOverScroll}"
    @click="click"
    style="cursor: pointer;"
  >
    <div>
      <Legend class="lbl-name" :indexCell="indexCell" v-if="isOverlap && sectionActive.id == section_id && indexCell == 0" style="color: #12A9FF; left: 126px;">
        {{ $t('engine.floatframeTool.floatframeHover.cell.lblCell', languageEngine) }}
      </Legend>
      <Legend class="lbl-name" :indexCell="indexCell" v-else style="color: #12A9FF;">
        {{ $t('engine.floatframeTool.floatframeHover.cell.lblCell', languageEngine) }}
      </Legend>
      <!-- <pre>{{ cellHover }}</pre> -->
    </div>
  </Wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import { Wrapper, Legend } from "./CellHover.styled";
export default {
  components: {
    Wrapper,
    Legend,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
    }
  },
  watch: {
    scrollPosition() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.cellHover.id,
        type: "CELL",
        action: "HOVER",
      });
    },
    mode() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.cellHover.id,
          type: "CELL",
          action: "HOVER",
        });
      });
    },
    cellHover: {
      deep: true,
      handler() {
        const element = document.getElementById("cell-hover-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      widgetHover: "designIframe/frame/widgetHover",
      sectionActive: "designIframe/frame/sectionActive",
      cellHover: "designIframe/frame/cellHover",
      cellActive: "designIframe/frame/cellActive",
      widgetActive: "designIframe/frame/widgetActive",
      gridHover: "designIframe/frame/gridHover",
      mode: "designIframe/mode",
      scrollPosition: "scrollPosition",
      components: "designIframe/metadata/components",
      detectDevice: "detectDevice",
      languageEngine: "designIframe/userPreference/languageEngine"
    }),
    isOverScroll() {
      this.scrollPosition;
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    grid_id() {
      if (this.cellHover.id) {
        return Object.entries(this.components).filter(
          (item) =>
            item[1].componentsID &&
            item[1].componentsID.includes(this.cellHover.id)
        )[0][0];
      } else {
        return null;
      }
    },
    indexCell() {
      if (this.grid_id) {
        if (this.detectDevice == 'mobile') {
          return this.components[this.grid_id].componentsIDMobile.indexOf(this.cellHover.id);
        } else {
          return this.components[this.grid_id].componentsID.indexOf(this.cellHover.id);
        }
      } else {
        return 0;
      }
    },
    section_id() {
      return this.grid_id && Object.entries(this.components).filter(
        (item) =>
          item[1].componentsID &&
          item[1].componentsID.includes(this.grid_id)
      )[0][0];
    },
    sectionComponent() {
      return this.section_id && this.components[this.section_id]
    },
    gridMarginTop() {
      return (
        this.components[this.grid_id] &&
        this.components[this.grid_id].style.marginTop
      );
    },
    indexGrid() {
      return this.sectionComponent.componentsID.indexOf(this.grid_id);
    },
    isFirstIndex() {
      return this.indexGrid == 0;
    },
    isOverlap() {
      return this.sectionComponent && this.sectionComponent.style.width == 'container-fluid' && this.isFirstIndex && this.gridMarginTop == 0
    }
  },
  methods: {
    click() {
      if (this.cellHover.id && this.grid_id) {
        this.$store.dispatch("designIframe/frame/setWidgetActive", {})
        this.$store.dispatch("designIframe/frame/setWidgetHover", {})
        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.cellHover.id],
        });
        this.$store.dispatch("designIframe/frame/setCellActive", {
          component_id: this.cellHover.id,
          parent_id: this.grid_id,
        });
      }
      this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      this.$store.dispatch("designIframe/frame/setSectionHover", {});
      // if (this.isGridOverlap) {
      //   this.$store.dispatch("designIframe/frame/setSectionActive", {
      //     component_id: this.section_id,
      //     name: this.section_id,
      //   });
      // } else {
      //   this.$store.dispatch("designIframe/frame/setSectionActive", {});
      // }
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
      this.$store.dispatch("designIframe/frame/setSectionActive", {
        component_id: this.section_id,
        name: this.section_id,
      });
      this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
    },
  },
};
</script>

<style lang="scss">
</style>